import { QFilterGeneric } from './QFilterGeneric'

export class QFilterProcesses extends QFilterGeneric {
  name = "processes_ids";
  class_name = "QFilterProcesses";
  api_name = 'affected_processes';
  chip_component = 'ChipProcesses';

  serialize(qfilters) {
    return encodeURIComponent(this.value);
  }
  
}
